<template>
  <v-app id="inspire" class="pgm-layout">
    <!-- 상단 네비게이션 바 -->
    <v-app-bar color="white" elevation="1" height="50" class="pgm-app-bar">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      
      <v-toolbar-title>
        CAION
           <!-- 관리자 권한 실행 중 표시 -->
      <v-chip 
        v-if="isImpersonating" 
        color="warning" 
        variant="flat" 
        size="small"
        class="ml-3 impersonate-badge"
      >
        <v-icon start size="small">mdi-shield-account</v-icon>
        관리자 권한으로 실행 중
      </v-chip>
      </v-toolbar-title>
      
   
      
      <v-spacer></v-spacer>
            
      <div class="mr-4 user-info">
        {{ userInfo?.m_sisul_name || '' }}
      </div>
      <!-- 사용자 정보 및 로그아웃 -->
      <v-menu class="user-menu">
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props" class="mr-2">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="goToUserInfo">
            <v-list-item-title>
              <v-icon size="small" class="mr-1">mdi-information-outline</v-icon>
              계정 정보
            </v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="handleLogout">
            <v-list-item-title>
              <v-icon size="small" class="mr-1">mdi-logout</v-icon>
              로그아웃
            </v-list-item-title>
          </v-list-item>
         
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- 사이드바 네비게이션 -->
    <v-navigation-drawer v-model="drawer" temporary>
      <v-list>
        <template v-for="item in menuItems" :key="item.title">
          <!-- 일반 메뉴 아이템 -->
          <v-list-item
            v-if="!item.children"
            :to="item.to"
            :prepend-icon="item.icon"
            :title="item.title"
            class="menu-item"
          ></v-list-item>
          
          <!-- 리스트 그룹 (재무회계) -->
          <v-list-group
            v-else
            :value="item.title"
            :prepend-icon="item.icon"
          >
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                :title="item.title"
                class="menu-item"
              ></v-list-item>
            </template>
            
            <v-list-item
              v-for="child in item.children"
              :key="child.title"
              :to="child.to"
              :prepend-icon="child.icon"
              :title="child.title"
              class="menu-item submenu-item"
            ></v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- 메인 콘텐츠 -->
    <v-main>
      <v-container fluid class="pa-0">
        <slot />
      </v-container>
    </v-main>

    <!-- 급여계산기 플로팅 컴포넌트 -->
    <WageCalc />
  </v-app>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import WageCalc from '../common/WageCalc.vue';

const store = useStore();
const router = useRouter();

// 로고 이미지
const logoImage = ref(new URL('../../assets/images/hypehive-logo.png', import.meta.url).href);

// 사이드바 상태
const drawer = ref(false);

// 사용자 정보 (Vuex에서 가져오기)
const userInfo = computed(() => store.getters.currentUser);

// 관리자 권한으로 실행 중인지 확인 (센터접속)
const isImpersonating = computed(() => store.getters.isImpersonating);

// 메뉴 아이템들
const menuItems = computed(() => [
  {
    title: '사원관리',
    icon: 'mdi-account-multiple-check',
    to: '/pgm/employees'
  },
  {
    title: '수급자 일정',
    icon: 'mdi-account-heart',
    to: '/pgm/fna/beneficiary'
  },
  {
    title: '임금관리',
    icon: 'mdi-clipboard-check-outline',
    to: '/pgm/wage/WageProcess'
  },
  {
    title: '기관운영현황',
    icon: 'mdi-chart-line',
    to: '/pgm/dashboard'
  },
  {
    title: '재무회계',
    icon: 'mdi-cash-multiple',
    children: [
      {
        title: '예산작성',
        icon: 'mdi-calculator',
        to: '/pgm/fna/budget'
      },
      {
        title: '현금출납부',
        icon: 'mdi-book-open-page-variant',
        to: '/pgm/fna/inout'
      }
    ]
  },
  {
    title: '설정',
    icon: 'mdi-cog',
    children: [
      {
        title: '공지사항',
        icon: 'mdi-bullhorn',
        to: '/pgm/notice'
      }
    ]
  }
]);

// 사용자 정보 페이지로 이동
const goToUserInfo = () => {
  router.push('/pgm/userinfo');
};

// 로그아웃 처리
const handleLogout = async () => {
  try {
    await store.dispatch('performLogout');
    router.push('/pgm/login');
  } catch (error) {
    console.error('로그아웃 오류:', error);
  }
};

// 컴포넌트 마운트 시 로그인 상태 확인
onMounted(async () => {
  await store.dispatch('validateAuth');
});
</script>

<style scoped>
@import '../../assets/styles/pgmLayout.scss';

.impersonate-badge {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}
</style>
